import React from 'react'

import ResetButton from './ResetButton'

export const Reset = () => {
  return <ResetButton />
}

export default Reset
